import { NextPage } from 'next/types';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

/**
 * ルートページ（/）
 * アクセスされた場合、即座にトップ画面（/top）へリダイレクトする。
 * このページ自体はコンテンツを持たない。
 */
const Index: NextPage = () => {
  const router = useRouter();
  useEffect(() => {
    router.replace('/top');
  }, []);

  return <div />;
};

export default Index;
